import { withDependencies } from '@wix/thunderbolt-ioc'
import {
	BrowserWindow,
	BrowserWindowSymbol,
	IAppDidMountHandler,
	Structure,
	IStructureStore,
} from '@wix/thunderbolt-symbols'
import { ViewerAPIProviderInitializer, ViewerManagerApi } from 'thunderbolt-viewer-manager-types'

export const TestApiEditorAppDidMountHandler = withDependencies(
	[BrowserWindowSymbol, Structure, ViewerManagerApi],
	(
		window: NonNullable<BrowserWindow>,
		structureStore: IStructureStore,
		viewerAPIProviderInitializer: ViewerAPIProviderInitializer
	): IAppDidMountHandler => ({
		appDidMount: async () => {
			const viewerAPI = viewerAPIProviderInitializer && (await viewerAPIProviderInitializer()).getViewerAPI()

			if (!window.testApi) {
				// @ts-ignore
				window.testApi = {
					viewerAPI,
					structureAPI: structureStore,
				}
			}
		},
	})
)
